// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"fbae3d61","379":"c6fa9131","555":"a9db008d","895":"6c8f36e7"}[chunkId] + ".css";
};